import React, { useCallback, useState, useEffect, useContext } from "react"
import { Model, ComputedUpdater } from 'survey-core'
import { Survey } from "survey-react-ui";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { useAuth0 } from "react-auth0-spa";
import { PlainLight } from "survey-core/themes";
import { useParams, Prompt } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, Button, Card, CardBody, CardHeader, CardTitle, Row, Col, Label, Input, FormGroup } from "reactstrap"
import { useHistory } from "react-router-dom";
import { useTwilioDevice } from "components/Phone/V1/useTwilioDevice";
import { cleanPhoneNumber } from "components/Phone/PhoneFunctions";
import { CallContext } from "context/CallContex";
import AgentService from "core/api/AgentService";


export default function ElevatorForm() {
    const [reportData, setReportData] = useState();
    const [buildingData, setBuildingData] = useState({});
    const [survey, setSurvey] = useState();
    const { user } = useAuth0();
    const { id } = useParams();
    const [reportSaved, setReportSaved] = useState(false);
    const [terminateReportPopup, setTerminateReportPopup] = useState(false);
    const [terminationReason, setTerminationReason] = useState("")
    const history = useHistory();
    const { makeOutgoingCall, holdCall, getActiveCall } = useTwilioDevice()
    const { calls } = useContext(CallContext)
    const [callContactPopup, setCallContactPopup] = useState({ visible: false, phoneNumber: "", questionName: "", newVal: null })
    const [showCall911Popup, setShowCall911Popup] = useState(false)

    const [saveBeforeLeave, setSaveBeforeLeave] = useState(false)
    const [reportTerminated, setReportTerminated] = useState(false)
    const [elevatorDisconnectCallInstructions, setElevatorDisconnectCallInstructions] = useState("")
    const [elevatorVideoInfo, setElevatorVideoInfo] = useState()
    const [testMode, setTestMode] = useState(false)

    const [requiresElevatorSelection, setRequiresElevatorSelection] = useState(false)
    const [selectedElevatorWhenMultiple, setSelectedElevatorWhenMultiple] = useState("")
    const [elevatorOptions, setElevatorOptions] = useState([])
    const [elevatorSelectionError, setElevatorSelectionError] = useState("")
    const [communicateThroughSMS, setCommunicateThroughSMS] = useState()

    const getSurveyJson = (unkownBuilding, videoInfo, recentCallsSummary) => {
        const hasRecentCalls = recentCallsSummary?.calls?.length > 0

        const callHistoryHtml = hasRecentCalls
            ? recentCallsSummary.calls.map(call => `
            <div style="padding: 10px; margin-bottom: 8px; background: #f8f9fa;
                        border-left: 3px solid #ffc107; border-radius: 3px;">
                ${call.displayText}
            </div>
        `).join("")
            : ""

        return {
        clearInvisibleValues: "onHidden",
        completeText: "Send Report",
        completedHtml: "<b><h2>Your Report Was Submitted</h2></b>",
        requiredText: "",
        showQuestionNumbers: false,
        showTimerPanel: "top",
        showTimerPanelMode: "survey", 
        pages: [
            {
                elements: [
                    {
                        type: "panel",
                        name: "introductionPanel",
                        title: "Introduction",
                        elements: [
                            {
                                type: "html",
                                name: "introduction",
                                html: "<p><b>Emergency Dispatch, How can I help you?</b></p>"
                            }
                        ]
                    },
                    {
                        name: "responseFromPerson",
                        title: "Did you get a response from the person in the elevator?",
                        type: "radiogroup",
                        choices: ["Yes", "No"],
                        isRequired: true
                    },
                    {
                        type: "panel",
                        name: "infoPanel",
                        title: "Video Instructions",
                        elements: [
                            {
                                type: "html",
                                name: "infoHtml",
                                html: `<div>
                                        <p><a href='${videoInfo.URL}' target='_blank'>Click here</a> to see video.</p>
                                        <p>${videoInfo.connectionInstructions ?? ""}</p>
                                     </div>`
                            }
                        ],
                        visibleIf: `{responseFromPerson} = 'No'  and ${unkownBuilding ? false : true} = 'true' and ${(videoInfo.URL != "" && videoInfo.URL != null) ? true : false} = 'true'`,
                    },
                    {
                        name: "checkVideo",
                        title: "What do you see?",
                        type: "dropdown",
                        choices: ["Call empty", "Person has hearing disability"],
                        visibleIf: `{responseFromPerson} = 'No' and ${unkownBuilding ? false : true} = 'true' and  ${(videoInfo.URL != "" && videoInfo.URL != null) ? true : false} = 'true'  `,
                        isRequired: true
                    },
                    {
                        name: "communicateByText",
                        title: "Communicate with person who has hearing disability",
                        type: "checkbox",
                        choices: [{ value: "Yes", text: "Text person to communicate" }],
                        visibleIf: `{checkVideo} = 'Person has hearing disability'  and ${unkownBuilding ? false : true} = 'true'`,
                        isRequired: true
                    },
                    {
                        name: "helpNeeded",
                        title: "Is help needed?",
                        type: "radiogroup",
                        choices: ["Yes", "No"],
                        visibleIf: "{responseFromPerson} = 'Yes' or {communicateByText} contains 'Yes' ",
                        isRequired: true
                    },
                    {
                        type: "panel",
                        name: "noResponseInstructionPanel",
                        title: "No Response Instructions",
                        elements: [
                            {
                                name: "instructionsForNoResponse",
                                type: "html",
                                html: "Disconnect the call and end the report.",
                            }
                        ],
                        visibleIf: `{checkVideo} = 'Call empty' or ({responseFromPerson} = 'No' and  ${(videoInfo.URL == "" || videoInfo.URL == null) ? true : false} = 'true')`,
                    },
                ]
            },
            {
                name: "DispatchPage",
                elements: [
                    {
                        name: "dispatch",
                        title: "What is wrong?",
                        type: "dropdown",
                        choices: ["Person stuck in elevator", "Medical Emergency"],
                        visibleIf: "{helpNeeded} = 'Yes'",
                        isRequired: true
                    },

                    //Recent calls section:
                    {
                        name: "previousCallsPanel",
                        title: "Recent Calls From This Elevator",
                        type: "panel",
                        visibleIf: hasRecentCalls ? "{dispatch} = 'Person stuck in elevator'" : "false",
                        elements: [{
                            type: "html",
                            name: "previousCallsInfo",
                            html: hasRecentCalls ? `
                                <div>
                                    <p style="font-weight: bold; margin-bottom: 10px;">
                                        ${recentCallsSummary.calls.length} call(s) in the last 6 hours:
                                    </p>
                                    ${callHistoryHtml}
                                </div>` : ""
                        }]
                    },
                    {
                        name: "sameIncident",
                        title: "Is this the same incident as any of the previous calls?",
                        type: "radiogroup",
                        choices: [
                            { value: "Yes", text: "Yes - passenger is still stuck" },
                            { value: "No", text: "No - this is a new/different incident" }
                        ],
                        isRequired: true,
                        visibleIf: hasRecentCalls ? "{dispatch} = 'Person stuck in elevator'" : "false"
                    },
                    {
                        name: "sameIncidentPanel",
                        type: "panel",
                        visibleIf: hasRecentCalls ? "{sameIncident} = 'Yes'" : "false",
                        elements: [
                            {
                                name: "tellPassengerHtml",
                                type: "html",
                                html: hasRecentCalls ? `
                                    <div style="padding: 15px; background: #fff3cd;
                                                border-radius: 5px; border: 1px solid #ffc107;
                                                margin-bottom: 15px;">
                                        <p style="margin: 0; font-size: 16px;">
                                            <strong>Tell the passenger:</strong><br/>
                                            "${recentCallsSummary.actionMessage}"
                                        </p>
                                    </div>` : ""
                            },
                            {
                                name: "sameIncidentWants911",
                                title: "Does the passenger want us to call 911?",
                                type: "radiogroup",
                                choices: ["Yes", "No"],
                                isRequired: true
                            }
                        ]
                    },

                    //Additional infor for dispatch:
                    {
                        type: "panel",
                        name: "AdditionalInfoForDispatch",
                        title: "Additional Information for Dispatch",
                        visibleIf: hasRecentCalls
                            ? "{dispatch} = 'Person stuck in elevator' and {sameIncident} = 'No'"
                            : "{dispatch} = 'Person stuck in elevator'",
                        elements: [{
                            name: "personsName",
                            title: "What is the person's name?",
                            type: "text",
                            isRequired: true
                        },
                        {
                            name: "personsNumber",
                            title: "What is the person's cell phone number?",
                            type: "text",
                            inputType: "tel",
                            isRequired: true
                        },
                        {
                            name: "durationStuck",
                            title: "How long has the person been stuck?",
                            type: "text",
                            isRequired: false
                        },
                        {
                            name: "locationStuck",
                            title: "Which floor are they stuck on/between?",
                            type: "text",
                            isRequired: false
                        },
                        ]
                    }
                ]
            },
            {
                name: "CommentsPage",
                elements: [
                    {
                        name: "notes",
                        title: "Additional Notes",
                        type: "comment"
                    }
                ]
            }
        ]
        }

    }

    const saveReport = async (sender, incomplete = false, reportInfo, terminate = false, communicateThroughSMSParam) => {
        let data = reportInfo ? reportInfo : reportData
        let communicateThroughSMSSetting = communicateThroughSMSParam ?? communicateThroughSMS

        let timeSpent = sender.timeSpent < 60 ? 1 : Math.trunc(sender.timeSpent / 60) 
        const surveyQuestions = sender.getAllQuestions(true)

        data = {
            ...data,
            callLength: timeSpent,
            surveyResults: sender.data,
        }

        if (terminate) {
            data = {
                ...data,
                surveyResults: { ...data.surveyResults, terminationReason: terminationReason },
                dateTimeSubmitted: new Date(), status: "terminated",
            }
        }

        if (!incomplete) {
            const lastQuestionBeforeNotes = surveyQuestions.at(surveyQuestions.length - 2)

            var resolution
            var smsMessage = null

            switch (lastQuestionBeforeNotes.name) {
                case "helpNeeded":
                    resolution = "No Help Needed"
                    break;
                case "instructionsForNoResponse":
                    resolution = "Call empty"
                    break;
                case "checkVideo":
                    resolution = lastQuestionBeforeNotes.value
                    break;
                case "911Confirmation":
                    var sameIncident = surveyQuestions.find(q => q.name === "sameIncident")?.value == "Yes"

                    if (lastQuestionBeforeNotes.value == "Yes") {
                        resolution = sameIncident ? "Dispatched to 911 (repeat incident)" : "Dispatched to 911"
                        smsMessage = sameIncident ? "We dispatched to 911 because passenger requested to call 911." : "We dispatched to 911."
                    } else {
                        resolution = sameIncident ? "Dispatched to 911 (repeat incident) without confirmation"
                            : "Dispatched to 911 without confirmation"
                        smsMessage = sameIncident ? "We dispatched to 911 because passenger requested to call 911, but did not get a confirmation."
                            : "We dispatched to 911 but did not get a confirmation."
                    }
                    break;
                default:
                    //handle contacts called and confirmed
                    if (lastQuestionBeforeNotes.name.toLowerCase().includes("confirmation") && lastQuestionBeforeNotes.value == "Yes") {
                        var contactName = surveyQuestions.at(surveyQuestions.length - 3).getPropertyValue("contactName")

                        if (lastQuestionBeforeNotes.name == "helpConfirmationElevatorCompany") {
                            resolution = "Called Available Elevator Company Contacts"
                            smsMessage = 'We called the available elevator company contacts and confirmed that help is on the way.'
                        } else if (contactName) { //building contact
                            resolution = "Called Building Contact"
                            smsMessage = `We called ${contactName} and confirmed that help is on the way.`
                        } else {
                            resolution = surveyQuestions.at(surveyQuestions.length - 3).title
                            smsMessage = `We called a contact and confirmed that help is on the way.`
                        }
                    } else if (lastQuestionBeforeNotes.name == 'sameIncidentWants911' && lastQuestionBeforeNotes.value == "No") {
                        resolution = "Passenger Still Stuck - Declined 911 call"
                        smsMessage = "Passenger remains stuck but declined offer to dispatch to 911."
                    }
                    else {
                        const dispatchValue = sender.getValue("dispatch")
                        if (dispatchValue === "Person stuck in elevator") {
                            resolution = communicateThroughSMSSetting
                                ? "Dispatched to Elevator Company via SMS"
                                : "Person stuck in elevator"

                            const { personsName, personsNumber, durationStuck, locationStuck } = data?.surveyResults;
                            smsMessage = `Help is needed.\nPassenger's name: ${personsName}\nNumber: ${personsNumber}`;
                            if (durationStuck) smsMessage += `\nTime stuck: ${durationStuck}`;
                            if (locationStuck) smsMessage += `\nFloor on/between: ${locationStuck}`;
                        } else {
                            resolution = "No Resolution"
                        }
                    }
            }

            data = {
                ...data,
                dateTimeSubmitted: new Date(), status: "submitted",
                resolution: resolution,
                smsMessage: smsMessage,
                surveyResults: { ...data.surveyResults, dispatchQuestions: sender.toJSON().pages.find(page => page.name == "DispatchPage").elements }
            }
        }

        const call = await AgentService.addCall(data);

        if (data.status == "submitted" || data.status == "terminated") {
            setSaveBeforeLeave(false)
            if (surveyQuestions.find(q => q.name == "call911")?.value == "Yes") {
                await AgentService.notifyContactsThat911Called(call)
            }

            await AgentService.sendCallSummaryReport(call)
        }
    };

    const terminateReport = () => {
        saveReport(survey, true, null, true)
        setReportTerminated(true)
        setTerminateReportPopup(false)
        //history.push(`../callcenter`)
        //window.close('', '_parent', '');
    }

    useEffect(() => {
        async function fetchData() {
            const reportResults = await AgentService.getReportData(id)

            if (reportResults.elevatorOptions?.length > 0 && !reportResults.call.elevatorId) {
                setRequiresElevatorSelection(true)
                setElevatorOptions(reportResults.elevatorOptions)
                setReportData(reportResults.call)
                setBuildingData(reportResults.building)
                return;
            } else {
                setRequiresElevatorSelection(false)
                setElevatorOptions([])
                setSelectedElevatorWhenMultiple("")
            }

            initializeReport(reportResults)
        }
        fetchData();
    }, [id]);

    const initializeReport = (reportResults) => {
        setReportData(reportResults.call)
        setBuildingData(reportResults.building)
        setElevatorDisconnectCallInstructions(reportResults.elevatorDisconnectCallInstructions)
        setTestMode(reportResults?.elevatorOnTestMode)
        setCommunicateThroughSMS(reportResults?.communicateThroughSMS)

        var videoInfo = { URL: reportResults?.elevatorVideoURL, connectionInstructions: reportResults?.elevatorVideoConnectionInstructions }
        setElevatorVideoInfo(videoInfo)

        var availableContacts = []

        if (reportResults.call.status == "answered") {

            reportResults?.building?.contacts?.forEach((contact) => {
                if (contact.availableForEmergencyCalls) {
                    availableContacts.push({ ...contact, type: "Building" })
                }
            })

            reportResults?.elevatorContacts?.forEach((contact) => {
                if (contact.availableForEmergencyCalls) {
                    availableContacts.push({ ...contact, type: "Elevator Company" })
                }
            })
        }

        setUpForm(reportResults.call, availableContacts, reportResults?.building?.dispatchTo911, reportResults.building == null, videoInfo, reportResults?.building?.informationFor911Dispatch, reportResults?.elevatorOnTestMode, reportResults?.communicateThroughSMS, reportResults.recentCallsSummary)
    }

    const handleElevatorSelection = async () => {
        if (!selectedElevatorWhenMultiple) {
            setElevatorSelectionError("Please select an elevator")
            return
        }

        setElevatorSelectionError("")

        const reportResults = await AgentService.selectElevatorForCall({
            Id: id,
            ElevatorId: selectedElevatorWhenMultiple
        })

        setRequiresElevatorSelection(false)
        initializeReport(reportResults)
    }


    const setUpForm = (data, availableContacts, call911, unknownBuilding, videoInfo, informationFor911Dispatch, elevatorOnTestMode, communicateThroughSMS, recentCallsSummary) => {
        const survey = new Model(getSurveyJson(unknownBuilding, videoInfo, recentCallsSummary))

        if (data.status == "answered") {
            survey.mode = "edit"
            setSaveBeforeLeave(true)

            survey.addNavigationItem({
                id: "sj-save-incomplete-survey",
                title: "Save Incomplete Form",
                action: () => { saveReport(survey, true, data, false, communicateThroughSMS); setReportSaved(true) },
                css: "nav-button",
                innerCss: "sd-btn nav-input",
                visibleIndex: 50,
                visible: new ComputedUpdater((() => { return survey.currentPage.name != "CommentsPage" }))
            });

            survey.addNavigationItem({
                id: "sj-save-incomplete-survey",
                title: "Terminate Call",
                action: () => { setTerminateReportPopup(true) },
                css: "nav-button",
                innerCss: "sd-btn nav-input",
                visibleIndex: 52,
                visible: new ComputedUpdater((() => { return survey.currentPage.name != "CommentsPage" }))
            });

            survey.onTextMarkdown.add((_, opt) => {
                if (opt.element?.name?.includes("callContact")) {
                    opt.html = opt.text.replace(/\n/g, "<br/>");
                }
            });

            let previousEC = []
            let numberLookup = {}

            survey.onValueChanged.add((sender, options) => {

                if (options.name.includes("callContact") && options.value == "Yes") {
                    setCallContactPopup({ visible: true, phoneNumber: cleanPhoneNumber(options.question.getPropertyValue("phoneNumber", "")), questionName: options.name })
                }
                if (options.name == "callContactsElevatorCompany" && options.value) {
                    const added = options.value?.filter(x => !previousEC.includes(x));

                    if (added.length > 0) {
                        const valueClicked = added[0];
                        const number = numberLookup[valueClicked];

                        if (number) {
                            setCallContactPopup({ visible: true, phoneNumber: cleanPhoneNumber(number), questionName: options.name, newVal: [...previousEC] })
                        }
                    }

                    previousEC = [...options.value]
                }
            })

            survey.onGetQuestionTitleActions.add((sender, options) => {
                if (options.question.name == "call911") {
                    options.actions = [{
                        id: "show-call-icon",
                        tooltip: elevatorOnTestMode ? "Call 933" : "Call 911",
                        title: elevatorOnTestMode ? "Call 933" : "Call 911",
                        visible: new ComputedUpdater((() => { return options.question.value?.includes("Yes") ?? false })), 
                        action: () => {
                            if (!showCall911Popup) {
                                setShowCall911Popup(true)
                            }
                        }
                    }]
                }
            })

            const dispatchPage = survey.getPageByName("DispatchPage")

            const hasRecentCalls = recentCallsSummary?.calls?.length > 0

            const buildingContacts = availableContacts.filter(contact => contact.type === "Building");
            const elevatorContacts = availableContacts.filter(contact => contact.type === "Elevator Company");

            for (let i = 0; i < buildingContacts.length; i++) {
                const contact = buildingContacts[i]

                const newQuestion = dispatchPage.addNewQuestion("checkbox", `callContact${i + 1}`)
                const responseQuestion = dispatchPage.addNewQuestion("radiogroup", `helpConfirmation${i + 1}`)

                newQuestion.title = `Call ${contact.type} Contact`
                newQuestion.choices = [{ value: "Yes", text: `Call <b>${contact.contactName ? contact.contactName : contact.type + " Contact"}</b> at ${contact.phone}` }]
                newQuestion.isRequired = true
                const baseCondition = i == 0
                    ? "{dispatch} = 'Person stuck in elevator'"
                    : `{helpConfirmation${i}} = 'No'`
                newQuestion.visibleIf = hasRecentCalls
                    ? `(${baseCondition}) and {sameIncident} = 'No'`
                    : baseCondition
                newQuestion.hasComment = true
                newQuestion.commentText = "Call Notes"
                newQuestion.setPropertyValue("phoneNumber", contact.phone)
                newQuestion.setPropertyValue("contactName", contact.contactName ? contact.contactName : contact.type + " Contact")

                responseQuestion.title = "Did you get a confirmation that help is on the way"
                responseQuestion.choices = ["Yes", "No"]
                responseQuestion.isRequired = true
                responseQuestion.visibleIf = `{callContact${i + 1}} contains 'Yes'`
            }

            // Add a single checkbox question for elevator contacts
            if (!communicateThroughSMS && elevatorContacts.length > 0) {
                const elevatorQuestion = dispatchPage.addNewQuestion("checkbox", "callContactsElevatorCompany");

                elevatorQuestion.title = "Call Available Elevator Company Contacts";
                elevatorQuestion.choices = elevatorContacts.map((contact, index) => {
                    numberLookup[`ElevatorContact${index + 1}`] = contact.phone;
                    return {
                        value: `ElevatorContact${index + 1}`,
                        text: `${contact.contactName ? `<b>${contact.contactName}:</b>` : "<b>Elevator Contact:</b>"} &nbsp; ${contact.phone} ${contact.phoneExtension ? `&nbsp;&nbsp;<i>Ext: ${contact.phoneExtension}</i>` : ""}
                        ${contact.phoneNotes ? `Notes: ${contact.phoneNotes}` : ""}
                    `,
                    }
                });
                elevatorQuestion.isRequired = true;
                const baseCondition = buildingContacts.length === 0
                    ? "{dispatch} = 'Person stuck in elevator'"
                    : `{helpConfirmation${buildingContacts.length}} = 'No'`
                elevatorQuestion.visibleIf = hasRecentCalls
                    ? `(${baseCondition}) and {sameIncident} = 'No'`
                    : baseCondition
                elevatorQuestion.hasComment = true;
                elevatorQuestion.commentText = "Call Notes";


                const elevatorConfirmation = dispatchPage.addNewQuestion("radiogroup", "helpConfirmationElevatorCompany");
                elevatorConfirmation.title = "Did you get a confirmation that help is on the way?";
                elevatorConfirmation.choices = ["Yes", "No"];
                elevatorConfirmation.isRequired = true;
                elevatorConfirmation.visibleIf = `{callContactsElevatorCompany.length} > 0`;
            }


            const questions = dispatchPage.getQuestions()
            const lastQuestion = questions.at(questions.length - 1).name

            const infoFor911DispatchPanel = dispatchPage.addNewPanel("infoFor911Dispatch"); 

            const base911Condition = `{dispatch} = 'Medical Emergency' ${!communicateThroughSMS && ((call911 || unknownBuilding) && (lastQuestion.includes("helpConfirmation"))) ? `or {${lastQuestion}} = 'No'` : ""}
                ${!communicateThroughSMS && ((call911 || unknownBuilding) && availableContacts.length == 0) ? "or {dispatch} = 'Person stuck in elevator'" : ""} `


            const contactListHtml = availableContacts.filter(c => c.type == "Building")
                .map(c => `<li>${c.contactName ? c.contactName : c.type + " Contact"} - ${c.phone}</li>`)
                .join("");

            infoFor911DispatchPanel.title = "Information for 911 Dispatch";
            const inforFor911DispatchHtml = infoFor911DispatchPanel.addNewQuestion("html", "infoFor911DispatchHtml");
            infoFor911DispatchPanel.visibleIf = hasRecentCalls
                ? `{dispatch} = 'Medical Emergency' or {sameIncidentWants911} = 'Yes' or ({sameIncident} = 'No' and (${base911Condition}))`
                : base911Condition
            inforFor911DispatchHtml.html = `
                <div> 
                ${informationFor911Dispatch ?
                    `<p>${informationFor911Dispatch?.replace(/\n/g, "<br/>")}</p>
                    <br />`
                    :
                    ""
                }
                    <p>Available building manager contacts: </p>
                ${contactListHtml == "" ? "<p>No available contacts</p>" :
                    `<ul>
                    ${contactListHtml}
                    </ul>`
                 }    
                   
                </div>`

            const call911Question = dispatchPage.addNewQuestion("checkbox", "call911")
            call911Question.title = "Dispatch to 911"
            call911Question.choices = [{ value: "Yes", text: "Call 911" }]
            call911Question.isRequired = true
            call911Question.visibleIf = hasRecentCalls
                ? `{dispatch} = 'Medical Emergency' or {sameIncidentWants911} = 'Yes' or ({sameIncident} = 'No' and (${base911Condition}))`
                : base911Condition
            call911Question.hasComment = true
            call911Question.commentText = "Call Notes"

            const call911Confirmation = dispatchPage.addNewQuestion("radiogroup", "911Confirmation")
            call911Confirmation.title = "Did you get a confirmation that help is on the way"
            call911Confirmation.choices = ["Yes", "No"]
            call911Confirmation.isRequired = true
            call911Confirmation.visibleIf = "{call911} contains 'Yes' "

        } else {
            survey.mode = "display"
            setSaveBeforeLeave(false)

            survey.onTextMarkdown.add((_, opt) => {
                if (opt.element?.name?.includes("callContact")) {
                    opt.html = opt.text.replace(/\n/g, "<br/>");
                }
            });

            if (data?.surveyResults?.dispatchQuestions) {
                const newSurveyJson = getSurveyJson(unknownBuilding, videoInfo, recentCallsSummary)
                newSurveyJson.pages.find(page => page.name == "DispatchPage").elements = data?.surveyResults?.dispatchQuestions
                survey.fromJSON(newSurveyJson)
            }
        }

        survey.data = data.surveyResults ? data.surveyResults : {}

        survey.applyTheme(PlainLight);

        survey.timeSpent = data.callLength * 60



        setSurvey(survey)
    }

    const callContact =() =>{
        const elevatorCall = calls.filter((callData) => callData.elevatorReportID == reportData?.id)[0]

        if (elevatorCall) {
            holdCall(elevatorCall.call, true);
        }

        makeOutgoingCall(callContactPopup.phoneNumber, user.email, buildingData?.outgoingPhoneNumberId);
    }

    const call911 = () => {
        const elevatorCall = calls.filter((callData) => callData.elevatorReportID == reportData?.id)[0]

        if (elevatorCall) {
            holdCall(elevatorCall.call, true);
        }

        const helpNumber = testMode ? "933" : "911"

        makeOutgoingCall(helpNumber, user.email, buildingData?.outgoingPhoneNumberId);
    }


    return (
        <>
            <PanelHeader content={
                <div className="header text-center">
                    <h1 className="title">
                        Elevator Report
                    </h1>
                    {reportData && 
                        <h2 className="title">
                            {reportData.elevatorPhoneNumber} - {reportData.elevatorName ?? "Unknown Elevator"}
                        </h2>
                    }

                </div>
            } />


            <Modal isOpen={reportSaved} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    <div className="title">Form was Saved</div>
                    <i className="las la-clipboard-check" style={{ fontSize: 60 }}></i>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setReportSaved(false)} style={{ margin: "auto", display: "block" }} >OK</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={terminateReportPopup} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    <div className="title">Terminate Report</div>
                    <i className="las la-phone-slash" style={{ fontSize: 60 }}></i>
                    <div>Enter termination reason</div>
                    <textarea onChange={(e) => setTerminationReason(e.target.value)} style={{ width: "65%" }}></textarea>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setTerminateReportPopup(false)} style={{ margin: "auto", display: "block" }} >Cancel</Button>
                    <Button color="primary" onClick={() => terminateReport()} style={{ margin: "auto", display: "block" }} >Terminate</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={callContactPopup.visible} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    <div className="title" style={{ fontSize: 18 }}>Call Contact</div>
                    <i className="las la-phone" style={{ fontSize: 40 }}></i>
                    <p style={{ fontSize: 16 }}>Do you want to put the elevator call on hold and call this contact at {callContactPopup.phoneNumber} ?</p>
                </ModalBody>
                <ModalFooter>     
                    <Button color="success" onClick={() => { callContact(); setCallContactPopup({ visible: false, phoneNumber: "", questionName: "" }) }} style={{ margin: "auto", display: "block" }} >Call</Button>
                    <Button color="danger" onClick={() => {
                        if (callContactPopup.newVal) {
                            survey.setValue(callContactPopup.questionName, callContactPopup.newVal);
                        } else {
                            survey.setValue(callContactPopup.questionName, "");
                        }

                        setCallContactPopup({ visible: false, phoneNumber: "", questionName: "" })
                    }}
                        style={{ margin: "auto", display: "block" }} >Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showCall911Popup} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    <div className="title" style={{ fontSize: 18 }}>Call {testMode ? "933" : "911"}</div>
                    <i className="las la-phone" style={{ fontSize: 40 }}></i>
                    <p style={{ fontSize: 16 }}>Are you sure you want to call {testMode ? "933" : "911"}?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={() => { call911(); setShowCall911Popup(false) }} style={{ margin: "auto", display: "block" }} >Call</Button>
                    <Button color="danger" onClick={() => { setShowCall911Popup(false) }} style={{ margin: "auto", display: "block" }} >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <div className="content">
                <Row>
                    <Col >
                        <Card>
                            <CardBody style={{ paddingTop: 0 }}>
                                <Row>
                                    <Col>
                                        <CardTitle tag="h4" style={{ marginTop: 10, fontWeight: "bold" }}>Dispatch Notes</CardTitle>
                                        <Label style={{ fontSize: 16, }}>
                                            {buildingData != null ?
                                                buildingData?.dispatchNotes ?? "No notes"
                                                : "Please put as many details as possible in additional notes. (Address, Zip Code...)"
                                            }
                                        </Label>
                                        {reportData?.buildingAddress &&
                                            <div>
                                                <Label style={{ fontSize: 16, }}>Address Recorded : {reportData.buildingAddress}</Label>
                                            </div>
                                        }

                                        {elevatorDisconnectCallInstructions &&
                                            <div>
                                                <Label style={{ fontSize: 16, }}>
                                                    <span style={{ fontWeight: "bold" }}>Elevator Disconnect Instructions</span> : {elevatorDisconnectCallInstructions}
                                                </Label>
                                            </div>
                                        }

                                        {(elevatorVideoInfo?.URL || elevatorVideoInfo?.connectionInstructions) &&
                                            <div>
                                                <Label style={{ fontSize: 16 }}>
                                                    <span style={{ fontWeight: "bold" }}>Elevator Video Info</span> {": "}

                                                    {elevatorVideoInfo?.URL &&
                                                        <a href={elevatorVideoInfo.URL} target="_blank" >View</a>
                                                    }

                                                    {elevatorVideoInfo.connectionInstructions &&
                                                        <>
                                                            {elevatorVideoInfo?.URL ?
                                                                <div style={{ paddingLeft: 10 }}>{elevatorVideoInfo.connectionInstructions}</div>
                                                                :
                                                                <span>{elevatorVideoInfo.connectionInstructions}</span>
                                                            }

                                                        </>}
                                                </Label>
                                            </div>
                                        }
                                    </Col>  

                                    {buildingData &&
                                        <Col>
                                            <CardTitle tag="h4" style={{ marginTop: 10, fontWeight: "bold" }}>Building - {buildingData?.buildingName}</CardTitle>
                                            <Label style={{ fontSize: 16, }}>
                                                <span style={{ fontWeight: "bold" }}>Address</span> : {buildingData?.line1}{buildingData?.line2 ? " " + buildingData?.line2 : ""},{" "} {buildingData?.city} {buildingData?.state} {buildingData?.postalCode}
                                            </Label>
                                        </Col>
                                    }
                                </Row>
                            </CardBody>
                        </Card>

                        {requiresElevatorSelection && (
                            <Card>
                                <CardBody style={{ paddingTop: 0 }}>
                                    <CardTitle tag="h4" style={{ fontWeight: "bold" }}>Select Elevator</CardTitle>
                                    <p style={{ fontSize: 16, marginBottom: 15 }}>
                                        This phone number is associated with multiple elevators. Please select which elevator this call is from:
                                    </p>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Input
                                                    type="select"
                                                    value={selectedElevatorWhenMultiple}
                                                    onChange={(e) => {
                                                        setSelectedElevatorWhenMultiple(e.target.value)
                                                        setElevatorSelectionError("")
                                                    }}
                                                    invalid={!!elevatorSelectionError}
                                                >
                                                    <option value="">Select Elevator</option>
                                                    {elevatorOptions?.map(elev => (
                                                        <option key={elev.id} value={elev.id}>
                                                            {elev.name}
                                                        </option>
                                                    ))}
                                                </Input>
                                                {elevatorSelectionError && (
                                                    <div style={{ color: "#ff3636", fontSize: 12, marginTop: 5 }}>
                                                        {elevatorSelectionError}
                                                    </div>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Button color="primary" onClick={handleElevatorSelection}>
                                        Continue with Report
                                    </Button>
                                </CardBody>
                            </Card>
                        )}

                        {!requiresElevatorSelection && (
                        <Card>
                            <CardBody>  
                                {reportTerminated ?
                                    <h2 style={{paddingTop: 20, fontWeight: "bold" , textAlign: "center"}}>Your Report Was Terminated</h2>
                                :
                                    survey && <Survey model={survey} onComplete={() => saveReport(survey)} />
                                }
                               
                            </CardBody>
                        </Card>
                        )}
                    </Col>
                </Row>

                <Prompt when={saveBeforeLeave} message ={(location, action) => {
                    saveReport(survey, true)
                    return true
                }}/>

            </div >
        </>
    )
}